import React from "react";
import AuthGuard from "../../components/guards/AuthGuard";
import Dashboard from "../../layouts/Dashboard";
import { Stack, Box, Typography, Button, Card } from "@mui/material";
import { AlertTriangle, RefreshCw, Home } from "react-feather";

const ErrorFallback = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };



  return (
    <AuthGuard>
      <Dashboard>
        <Stack
          alignItems="center"
          justifyContent="center"
          height="100vh"
          sx={{
            background: "linear-gradient(135deg, #F7F9FC 0%, #E8F2FF 100%)",
            padding: "2rem",
          }}
        >
          <Card
            sx={{
              maxWidth: "500px",
              width: "100%",
              padding: "3rem 2rem",
              textAlign: "center",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(63, 128, 234, 0.08)",
              border: "1px solid rgba(63, 128, 234, 0.1)",
              background: "linear-gradient(145deg, #ffffff, #fcfcff)",
            }}
          >
            {/* Error Icon */}
            <Box
              sx={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #FF6B6B, #FF8E8E)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 2rem",
                boxShadow: "0 8px 20px rgba(255, 107, 107, 0.3)",
              }}
            >
              <AlertTriangle size={40} color="white" />
            </Box>

            {/* Error Message */}
                         <Typography
               variant="h4"
               sx={{
                 fontSize: "1.4rem",
                 fontWeight: "700",
                 marginBottom: "1rem",
                 background: "linear-gradient(45deg, #495057, #6c757d)",
                 WebkitBackgroundClip: "text",
                 WebkitTextFillColor: "transparent",
                 fontFamily: "Poppins, sans-serif",
               }}
             >
               Oops! Something went wrong
             </Typography>

             <Typography
               sx={{
                 fontSize: "0.85rem",
                 color: "#6c757d",
                 marginBottom: "2.5rem",
                 lineHeight: "1.6",
                 fontWeight: "400",
               }}
             >
              We encountered an unexpected error while processing your request.
              <br />
              Our team has been notified and is working on a fix.
            </Typography>



            {/* Action Buttons */}
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
              <Button
                variant="contained"
                onClick={handleRefresh}
                startIcon={<RefreshCw size={18} />}
                sx={{
                  backgroundColor: "#3F80EA",
                  color: "white",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(63, 128, 234, 0.3)",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#3651FE",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 16px rgba(63, 128, 234, 0.4)",
                  },
                }}
              >
                Try Again
              </Button>

              <Button
                variant="outlined"
                onClick={handleGoHome}
                startIcon={<Home size={18} />}
                sx={{
                  borderColor: "#3F80EA",
                  color: "#3F80EA",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                  textTransform: "none",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderColor: "#3651FE",
                    backgroundColor: "rgba(63, 128, 234, 0.05)",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                Go Home
              </Button>

            </Stack>



            {/* Subtle branding */}
            <Box
              sx={{
                marginTop: "2rem",
                padding: "1rem",
                backgroundColor: "rgba(63, 128, 234, 0.03)",
                borderRadius: "8px",
                border: "1px solid rgba(63, 128, 234, 0.1)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.7rem",
                  color: "#556ee6",
                  fontWeight: "500",
                  letterSpacing: "0.5px",
                }}
              >
                💡 DataJolt
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.65rem",
                  color: "#6c757d",
                  marginTop: "0.5rem",
                }}
              >
                Error ID: {Date.now().toString(36).toUpperCase()}
              </Typography>
            </Box>
          </Card>
        </Stack>
      </Dashboard>
    </AuthGuard>
  );
};

export default ErrorFallback;
